import { useState } from "react";
import { useNavigate } from "react-router";
import { ImageWithFallback } from "../components/figma/ImageWithFallback";
import { Lock, User } from "lucide-react";
import { Logo } from "../components/Logo";

export function FinalLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulated login - in production, this would validate credentials
    if (username && password) {
      navigate("/confidential");
    } else {
      alert("Please enter both username and password");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-20">
        <ImageWithFallback
          src="https://images.unsplash.com/photo-1599949104055-2d04026aee1e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB0ZWNobm9sb2d5JTIwZGF0YSUyMGNlbnRlciUyMHNlcnZlcnN8ZW58MXx8fHwxNzc1MjA4NjU4fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
          alt="Background"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-4xl mx-auto px-8 py-16 min-h-screen flex flex-col justify-center">
        {/* Logo */}
        <div className="mb-8">
          <Logo className="w-16 h-16" />
        </div>

        {/* Header */}
        <div className="mb-12">
          <p className="text-sm uppercase tracking-wide text-gray-600 mb-4">
            AUTHORISED ACCESS ONLY
          </p>
          <h1 className="text-5xl text-gray-900 mb-8 leading-tight">
            Proceed With Authorised Credentials
          </h1>
          <div className="space-y-4 text-gray-700 max-w-2xl">
            <p>
              Access to LEO Group's private portal is available exclusively to vetted institutional investors, board members, and authorised strategic partners. All sessions are monitored, time-restricted, and logged in compliance with the group's information security and confidentiality framework.
            </p>
          </div>
        </div>

        {/* Info Box */}
        <div className="bg-blue-100 border-l-4 border-blue-600 p-6 mb-12 max-w-2xl">
          <p className="text-gray-800">
            If you have not yet been granted access and believe you qualify as an authorised stakeholder, submit a formal access request including your name, organisation, contact details, and the nature of your interest. All requests are subject to review and approval by LEO Group's governance team.
          </p>
        </div>

        {/* Login Form */}
        <div className="bg-white p-8 rounded-lg shadow-lg max-w-2xl mb-8">
          <h2 className="text-2xl text-gray-900 mb-6">Login Credentials</h2>
          <form onSubmit={handleLogin}>
            <div className="mb-6">
              <label
                className="block text-gray-700 mb-2"
                htmlFor="username"
              >
                Username
              </label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  className="w-full border border-gray-300 rounded py-3 px-10 text-gray-700 focus:outline-none focus:border-blue-600 transition-colors"
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your username"
                  required
                />
              </div>
            </div>
            <div className="mb-6">
              <label
                className="block text-gray-700 mb-2"
                htmlFor="password"
              >
                Password
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  className="w-full border border-gray-300 rounded py-3 px-10 text-gray-700 focus:outline-none focus:border-blue-600 transition-colors"
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                />
              </div>
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-3 rounded hover:bg-blue-700 transition-colors mb-4"
            >
              Secure Login
            </button>
          </form>
        </div>

        {/* Buttons */}
        <div className="flex gap-4 max-w-2xl">
          <button
            onClick={() =>
              alert(
                "Access request form would be shown here. Please contact LEO Group management for authorised access."
              )
            }
            className="border-2 border-blue-600 text-blue-600 px-8 py-3 rounded hover:bg-blue-50 transition-colors"
          >
            Request Access
          </button>
          <button
            onClick={() => navigate("/")}
            className="border-2 border-gray-300 text-gray-700 px-8 py-3 rounded hover:bg-gray-100 transition-colors"
          >
            Back to Public Website
          </button>
        </div>
      </div>
    </div>
  );
}